import { Helmet, HelmetProvider } from "react-helmet-async";
import { generateRandomNumber } from "../helper/common";
import { getMeniny } from "../helper/module/meniny/getMeniny";

/**
 * returns formated clock
 * @param props
 * @returns
 */
const Meniny = (props) => {
  const {
    moduleSettings,
    country,
    todayText,
    tomorrowText,
    showTomorrow,
    allParams,
  } = props;
  const tomorrowFormatedText = tomorrowText !== undefined ? tomorrowText : "";
  const googleFontLink = moduleSettings.googleFontLink;
  const { today, tomorrow } = getMeniny(country);
  const todayFormated = today ? today : todayText;
  const tomorrowFormated = tomorrow ? tomorrow : tomorrowText;
  const fontFamily =
    moduleSettings?.specialData?.allParams?.mapValue?.fields?.google_font
      ?.mapValue?.fields?.value?.stringValue || "Montserrat";
  const fontColor =
    allParams.font_color.mapValue.fields.value.stringValue || "#fafafc";
  const fontSize =
    allParams.font_size.mapValue.fields.value.stringValue + "px" || "30px";
  const textAlign =
    allParams.horizontal_position.mapValue.fields.value.stringValue || "center";
  let meninyHtml = `
    <div style="font-family:${fontFamily};font-style:italic;font-weight:300;text-align:${textAlign};font-size:${fontSize};color:${fontColor}">
      ${todayText}${todayFormated}
    </div>
  `;
  if (showTomorrow === "on" || showTomorrow !== "") {
    meninyHtml = `
    <div style="font-family:${fontFamily};font-style:italic;font-weight:300;text-align:${textAlign};font-size:${fontSize};color:${fontColor}">
      ${todayText}${todayFormated}<br>${tomorrowFormatedText}${tomorrowFormated}
    </div>
  `;
  }

  return (
    <div>
      <HelmetProvider>
        {googleFontLink && (
          <Helmet>
            <link href={googleFontLink} rel="stylesheet" />
          </Helmet>
        )}
      </HelmetProvider>
      <div dangerouslySetInnerHTML={{ __html: meninyHtml }} />
    </div>
  );
};

export default Meniny;
